import {setScroll} from "../Helpers/Scroll";

const selectors = {
    map: '.js--map',
};

class MapVector {

    constructor() {
        this.centerScrollMap();
    }

    centerScrollMap() {
        const map = document.querySelector(selectors.map);

        if (!map) {
            return;
        }

        setScroll(map);
        window.addEventListener('resize', setScroll(map));
    }
}

export default MapVector;
